"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineModule = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var GSWrapperComponent_1 = require("../../../../GSWrapperComponent");
var Timeline_1 = require("./Timeline");
var TimelineModule = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineModule, _super);
    function TimelineModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimelineModule.prototype.render = function () {
        return (React.createElement(GSWrapperComponent_1.GSWrapperComponent, { globalStore: this.props.globalStore },
            React.createElement(Timeline_1.Timeline, null)));
    };
    TimelineModule = tslib_1.__decorate([
        mobx_react_1.inject('globalStore')
    ], TimelineModule);
    return TimelineModule;
}(React.Component));
exports.TimelineModule = TimelineModule;
